import { Box, Button } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FilterChipWrapper = styled(Box)`
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  gap: ${theme.spacing.xSmall}px;
  flex-shrink: 0; /* Prevent shrinking */

  &.reset-wrapper {
    align-self: flex-end;
  }
`

export const FilterButton = styled(Button)`
  border-radius: ${theme.attributes.borderRadius.tertiary};
  border: 1px solid #4e444b;
  gap: ${theme.spacing.small}px;
  padding: 14px ${theme.spacing.small}px;
  height: 48px;
  min-height: 48px;
  color: ${theme.colors.textPrimary};
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-style: normal;
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  text-transform: none;
  background: transparent;
  justify-content: flex-start;
  white-space: nowrap;
  max-width: 400px; /* Limit maximum width */
  min-width: fit-content; /* Ensure button doesn't get too small */
  overflow: hidden; /* Hide overflow */

  html[data-theme='light'] & {
    background: ${theme.colors.surfaceContainerBackground};
    border-color: ${theme.colors.strokeSecondary};
  }

  .filter-chip-filter-name {
    color: #a88ca4;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    margin-right: -10px;
    flex-shrink: 0; /* Don't shrink the label */

    html[data-theme='light'] & {
      color: ${theme.colors.textCaption};
    }
  }

  & .text {
    color: ${theme.colors.textPrimary};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    text-transform: none;
    flex-grow: 1;
    text-align: left;
    white-space: nowrap; /* Keep text on one line */
    overflow: hidden;
    text-overflow: ellipsis; /* Add ellipsis for overflow */
    max-width: 300px; /* Limit text width */
  }

  &:hover {
    border-color: #6c5b67;

    .MuiIconButton-root {
      svg {
        path {
          stroke: ${theme.colors.textPrimary};
        }
      }
    }
  }

  &.filter-chip-reset-button {
    color: ${theme.colors.devicesSecondaryText};
    width: auto; /* Auto width for reset button */
    min-width: 100px; /* Minimum width for reset button */
    max-width: none; /* No max width limit for reset button */

    html[data-theme='light'] & {
      color: ${theme.colors.btnSecondaryText};
    }

    &:hover {
      color: ${theme.colors.menuItemText};
      background: ${theme.colors.borderMedium};
      border-color: ${theme.colors.borderMedium};
    }
  }

  .MuiIconButton-root {
    padding: 0;
    flex-shrink: 0; /* Don't shrink the close button */
  }
`

export const popperPropsSx = {
  sx: {
    marginTop: `-${theme.spacing.sm}px !important`,
    zIndex: 1000000000,

    '.MuiTooltip-tooltip': {
      maxHeight: '300px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',

      '.note-text': {
        fontSize: '12px !important'
      },

      '&::after': {
        content: '""',
        display: 'block',
        minHeight: '0px',
        flexShrink: 0
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: theme.colors.textPrimary,
        borderRadius: theme.attributes.borderRadius.quaternary
      }
    }
  }
}
